// src/components/dashboard/cases/newCase/case_id/appointmentLabel.js
// OPTIMIZED: caseData prop se data leta hai, sirf PUT pe API hit

import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AppointmentLabel = ({ caseId, initialAppointment, caseData, onUpdate }) => {
  const [selectedAppointmentDate, setSelectedAppointmentDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Sync from caseData
  useEffect(() => {
    const source = caseData?.appointment ?? initialAppointment ?? '';
    setSelectedAppointmentDate(source);
  }, [caseData?.appointment, initialAppointment]);

  const handleDateChange = async (e) => {
    const newDate = e.target.value;
    setSelectedAppointmentDate(newDate);

    // Optimistic update
    if (onUpdate) onUpdate({ appointment: newDate });

    try {
      await axios.put(
        `https://hms.backend.hiragroupcloud.com/api/cases/cases/${caseId}`,
        { appointment: newDate }
      );
    } catch (error) {
      console.error('❌ Error updating appointment date:', error);
      // Revert on error
      setSelectedAppointmentDate(caseData?.appointment || '');
    }
  };

  return (
    <div style={{ margin: '0', padding: '0', textAlign: 'left' }}>
      <style>
        {`
          @media (max-width: 768px) {
            .appointment-label-text { font-size: 10px !important; margin-bottom: 2px !important; }
            .appointment-date-input { font-size: 8px !important; padding: 1px 4px !important; height: 20px !important; min-height: 20px !important; max-height: 20px !important; line-height: 1 !important; max-width: 120px !important; box-sizing: border-box !important; }
            .appointment-date-input::-webkit-datetime-edit { font-size: 8px !important; padding: 0 !important; line-height: 1 !important; }
            .appointment-date-input::-webkit-datetime-edit-fields-wrapper { font-size: 8px !important; padding: 0 !important; line-height: 1 !important; }
            .appointment-date-input::-webkit-datetime-edit-text { font-size: 8px !important; padding: 0 !important; line-height: 1 !important; }
            .appointment-date-input::-webkit-datetime-edit-month-field,
            .appointment-date-input::-webkit-datetime-edit-day-field,
            .appointment-date-input::-webkit-datetime-edit-year-field { font-size: 8px !important; padding: 0 !important; line-height: 1 !important; }
            .appointment-date-input::-webkit-calendar-picker-indicator { width: 8px !important; height: 8px !important; padding: 0 !important; margin: 0 !important; transform: scale(0.6) !important; cursor: pointer !important; }
          }
        `}
      </style>

      <p
        className="appointment-label-text"
        style={{
          fontWeight: 'bold', fontSize: '16px', margin: '0 0 4px 0',
          padding: '0', textAlign: 'left',
        }}
      >
        Patient Appointment:
      </p>

      <div style={{ display: 'flex', margin: '0', padding: '0' }}>
        <input
          type="date"
          value={isLoading ? '' : selectedAppointmentDate}
          onChange={handleDateChange}
          className="form-control me-2 appointment-date-input"
          style={{
            padding: '7px 14px', border: '1px solid #ccc',
            borderRadius: '4px', width: 'auto', margin: '0',
          }}
          disabled={isLoading}
        />
      </div>
    </div>
  );
};

export default AppointmentLabel;